class FacetFiltersFormMobile extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
  
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 800);
  
      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
  
      const facetWrapper = this.querySelector('#FacetsWrapperMobile');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
  
    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersFormMobile.searchParamsInitial;
        if (searchParams === FacetFiltersFormMobile.searchParamsPrev) return;
        FacetFiltersFormMobile.renderPage(searchParams, null, false);
      };
      window.addEventListener('popstate', onHistoryChange);
    }
  
    static toggleActiveFacets(disable = true) {
      document.querySelectorAll('.js-facet-remove').forEach((element) => {
        element.classList.toggle('disabled', disable);
      });
    }
  
    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersFormMobile.searchParamsPrev = searchParams;
      const sections = FacetFiltersFormMobile.getSections();
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form-mobile .loading__spinner'
      );
  
      loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
  
      const productGridContainer = document.getElementById('ProductGridContainer');
      if (productGridContainer) {
        const collection = productGridContainer.querySelector('.collection');
        if (collection) collection.classList.add('loading');
      }
  
      if (countContainer) countContainer.classList.add('loading');
      if (countContainerDesktop) countContainerDesktop.classList.add('loading');
  
      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;
  
        FacetFiltersFormMobile.filterData.some(filterDataUrl)
          ? FacetFiltersFormMobile.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersFormMobile.renderSectionFromFetch(url, event);
      });
  
      if (updateURLHash) FacetFiltersFormMobile.updateURLHash(searchParams);
    }
    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersFormMobile.filterData = [...FacetFiltersFormMobile.filterData, { html, url }];
          FacetFiltersFormMobile.renderFilters(html, event);
          FacetFiltersFormMobile.renderProductGridContainer(html);
          FacetFiltersFormMobile.renderProductCount(html);
          FacetFiltersFormMobile.renderActiveFacets(html);
          FacetFiltersFormMobile.renderSortOptions(html);
          FacetFiltersFormMobile.renderPagination(html);
        });
    }

    static renderPagination(html) {
        const parsedHTML = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
        
        // Get pagination from fetched HTML
        const newPagination = parsedHTML.getElementById('product-collection--infini');
        const currentPagination = document.getElementById('product-collection--infini');
        
        if (newPagination && currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        }
    }

    static renderSortOptions(html) {
        const parsedHTML = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
        
        // Get sort options from fetched HTML
        const newSortOptions = parsedHTML.querySelectorAll('#FacetSortFormMobile input[type="radio"]');
        const currentSortOptions = document.querySelectorAll('#FacetSortFormMobile input[type="radio"]');
        
        if (newSortOptions.length > 0 && currentSortOptions.length > 0) {
          // Update checked state for each option
          newSortOptions.forEach((newOption, index) => {
            if (currentSortOptions[index]) {
              currentSortOptions[index].checked = newOption.checked;
              
              // Update active class on label
              const currentLabel = currentSortOptions[index].closest('.mobile-facets__sort-option');
              if (currentLabel) {
                if (newOption.checked) {
                  currentLabel.classList.add('active');
                } else {
                  currentLabel.classList.remove('active');
                }
              }
            }
          });
        }
      }
    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersFormMobile.filterData.find(filterDataUrl).html;
      FacetFiltersFormMobile.renderFilters(html, event);
      FacetFiltersFormMobile.renderProductGridContainer(html);
      FacetFiltersFormMobile.renderProductCount(html);
      FacetFiltersFormMobile.renderActiveFacets(html);
      FacetFiltersFormMobile.renderSortOptions(html);
      FacetFiltersFormMobile.renderPagination(html);
    }
  
    static renderProductGridContainer(html) {
        const newDoc = new DOMParser().parseFromString(html, 'text/html');
        const newContainer = newDoc.getElementById('ProductGridContainer');
        const currentContainer = document.getElementById('ProductGridContainer');
        
        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
          
          // Remove loading class
          const collection = currentContainer.querySelector('.collection');
          if (collection) {
            collection.classList.remove('loading');
          }
        }
        
        // Check if there are products (check in current DOM after update)
        const collectionGrid = document.querySelector('#collection');
        const products = collectionGrid ? collectionGrid.querySelectorAll('.halo-column__item') : [];
        const noProductsMessage = document.getElementById('NoProductsMessage');
        const paginationContainer = document.getElementById('product-collection--infini');
        const mainContainer = document.querySelector('#ProductGridContainer').parentElement;
        
        if (products.length === 0) {
          // No products found - show empty state
          if (noProductsMessage) {
            noProductsMessage.style.display = 'block';
          }
          if (mainContainer) {
            mainContainer.style.display = 'none';
          }
          if (paginationContainer) {
            paginationContainer.style.display = 'none';
          }
        } else {
          // Products found - show grid
          if (noProductsMessage) {
            noProductsMessage.style.display = 'none';
          }
          if (mainContainer) {
            mainContainer.style.display = 'block';
          }
          if (paginationContainer) {
            paginationContainer.style.display = 'block';
          }
        }
      }
  
    static renderProductCount(html) {
      const newDoc = new DOMParser().parseFromString(html, 'text/html');
      const newCount = newDoc.getElementById('ProductCount');
      const newCountDesktop = newDoc.getElementById('ProductCountDesktop');
      const newCountMobile = newDoc.getElementById('ProductCountMobile');
      const newCountMobileButton = newDoc.getElementById('ProductCountMobileButton');
      const newFilterCount = newDoc.getElementById('MobileFilterCount');

      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      const containerMobile = document.getElementById('ProductCountMobile');
      const containerMobileButton = document.getElementById('ProductCountMobileButton');
      const containerFilterCount = document.getElementById('MobileFilterCount');
      if (newCount && container) {
        container.innerHTML = newCount.innerHTML;
        container.classList.remove('loading');
      }
  
      if (newCountDesktop && containerDesktop) {
        containerDesktop.innerHTML = newCountDesktop.innerHTML;
        containerDesktop.classList.remove('loading');
      }
  
      if (newCountMobile && containerMobile) {
        containerMobile.innerHTML = newCountMobile.innerHTML;
        containerMobile.classList.remove('loading');
      }

      if (newCountMobileButton && containerMobileButton) {
        containerMobileButton.innerHTML = newCountMobileButton.innerHTML;
      }

      if (newFilterCount && containerFilterCount) {
        containerFilterCount.innerHTML = newFilterCount.innerHTML;
      }

      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form-mobile .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    }
  
    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__details');
      const facetDetailsElementsFromDom = document.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__details');
  
      // Remove facets no longer returned
      Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
        if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
          currentElement.remove();
        }
      });
  
      const matchesId = (element) => {
        const jsFilter = event ? event.target.closest('.mobile-facets__details') : undefined;
        return jsFilter ? element.id === jsFilter.id : false;
      };
  
      const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((el) => !matchesId(el));
      const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
  
      facetsToRender.forEach((el, index) => {
        const currentElement = document.getElementById(el.id);
        if (currentElement) {
          currentElement.innerHTML = el.innerHTML;
        } else {
          if (index > 0) {
            const { className: prevClass, id: prevId } = facetsToRender[index - 1];
            if (el.className === prevClass) {
              document.getElementById(prevId).after(el);
              return;
            }
          }
          if (el.parentElement) {
            const targetParent = document.querySelector(`#${el.parentElement.id} .mobile-facets__details`);
            if (targetParent) targetParent.before(el);
          }
        }
      });
  
      if (countsToRender) {
        const closestJSFilterID = event.target.closest('.mobile-facets__details').id;
        if (closestJSFilterID) {
          FacetFiltersFormMobile.renderCounts(countsToRender, document.getElementById(closestJSFilterID));
          const newElementToActivate = document.getElementById(closestJSFilterID).querySelector('.mobile-facets__summary');
          const isTextInput = event.target.getAttribute('type') === 'text';
          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }
  
    static renderActiveFacets(html) {
      const parsedHTML = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
      
      // Update active facets inside drawer
      const activeFacetsElement = parsedHTML.querySelector('.active-facets-mobile');
      const currentActiveFacets = document.querySelector('.active-facets-mobile');
      if (activeFacetsElement && currentActiveFacets) {
        currentActiveFacets.innerHTML = activeFacetsElement.innerHTML;
      }
      
      // Update active facets outside drawer
      const activeFacetsOutsideElement = parsedHTML.querySelector('.active-facets-mobile-outside');
      const currentActiveFacetsOutside = document.querySelector('.active-facets-mobile-outside');
      if (activeFacetsOutsideElement && currentActiveFacetsOutside) {
        currentActiveFacetsOutside.innerHTML = activeFacetsOutsideElement.innerHTML;
      }
      
      FacetFiltersFormMobile.toggleActiveFacets(false);
    }
  
    static renderCounts(source, target) {
      const targetSummary = target.querySelector('.mobile-facets__summary');
      const sourceSummary = source.querySelector('.mobile-facets__summary');
      if (sourceSummary && targetSummary) targetSummary.outerHTML = sourceSummary.outerHTML;
    }
  
    static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  
    static getSections() {
      const productGrid = document.getElementById('collection');
      return [
        {
          section: productGrid ? productGrid.dataset.id : document.querySelector('[data-section-id]').dataset.sectionId,
        },
      ];
    }
  
    createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    }
  
    onSubmitForm(searchParams, event) {
      FacetFiltersFormMobile.renderPage(searchParams, event);
    }
  
    onSubmitHandler(event) {
      event.preventDefault();
      const mobileForms = document.querySelectorAll('facet-filters-form-mobile form');
      const forms = [];
      mobileForms.forEach((form) => {
        if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  
    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersFormMobile.toggleActiveFacets();
      const url =
        event.currentTarget.href.indexOf('?') === -1
          ? ''
          : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersFormMobile.renderPage(url);
    }
  }
  
  FacetFiltersFormMobile.filterData = [];
  FacetFiltersFormMobile.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersFormMobile.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form-mobile', FacetFiltersFormMobile);
  FacetFiltersFormMobile.setListeners();


  class FacetSortFormMobile extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
    }
  
    onSubmitHandler(event) {
      event.preventDefault();
      const formData = new FormData(this.form);
      const sortValue = formData.get('sort_by');
      
      // Get current URL params
      const currentUrl = new URL(window.location.href);
      const searchParams = new URLSearchParams(currentUrl.search);
      
      // Update sort_by param
      searchParams.set('sort_by', sortValue);
      
      // Trigger the mobile form update
      FacetFiltersFormMobile.renderPage(searchParams.toString(), event);
      
      // Close the dropdown
      this.classList.add('hidden');
    }
  }
  
  customElements.define('facet-sort-form-mobile', FacetSortFormMobile);


document.addEventListener('DOMContentLoaded', function() {
  const sortTrigger = document.querySelector('.mobile-facets__sort-trigger');
  const sortDropdown = document.querySelector('.mobile-facets__sort-dropdown');
  
  if (sortTrigger && sortDropdown) {
    sortTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      sortDropdown.classList.toggle('hidden');
      sortTrigger.classList.toggle('active');
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(event) {
      const sortWrapper = document.querySelector('.mobile-facets__sort-wrapper');
      if (sortWrapper && !sortWrapper.contains(event.target)) {
        sortDropdown.classList.add('hidden');
        sortTrigger.classList.remove('active');
      }
    });
    
    // Prevent closing when clicking inside dropdown
    sortDropdown.addEventListener('click', function(event) {
      event.stopPropagation();
    });
  }
});